<div class="jobs-carousel-container" style="position: relative;">

    <!-- AVT2-6: prevButtonAriaLabel / nextButtonAriaLabel give the PrimeNG carousel arrow buttons
     meaningful accessible names, and the SCSS ensures the focus outline is visible on those buttons. -->
    <p-carousel [value]="jobs" [numVisible]="currentNumVisible" [numScroll]="1" [responsiveOptions]="responsiveOptions"
        [circular]="false" styleClass="custom-carousel" [class]="'p-carousel-items-' + jobs.length"
        [showIndicators]="false" prevButtonAriaLabel="Previous jobs" nextButtonAriaLabel="Next jobs" [page]="page"
        (onPage)="onPageChange($event)">

        <ng-template pTemplate="item" let-job>
            <div class="job-card">
                <div class="job-card-content">
                    <div *ngFor="let oQ of displayRenderedFields(job.Questions); let j = index" class="jobValues">
                        <!-- AVT2-3: Job title link must receive a visible focus outline.
                         The h3 uses overflow:hidden which clips outlines; the SCSS focus-within rule
                         flips it to overflow:visible so the ring paints. -->
                        <h3 *ngIf="oQ.ClassName === 'jobtitle'">
                            <a [id]="'MapJob_' + jobs.indexOf(job)" [ngClass]="oQ.ClassName"
                                [attr.title]="oQ.Value | htmlDecode" class="jobProperty jobtitle dothover"
                                [tabindex]="isItemVisible(jobs.indexOf(job)) ? 0 : -1"
                                (click)="onJobTitleClickFromMouse($event, job, 'MapJob_' + jobs.indexOf(job))"
                                (keydown.enter)="onJobTitleClickFromKeyboard($event, job, 'MapJob_' + jobs.indexOf(job))"
                                role="link" [attr.aria-label]="(oQ.Value | htmlDecode)">{{oQ.Value | truncate:25 |
                                htmlDecode}}</a>
                        </h3>
                        <!-- Other fields -->
                        <p *ngIf="oQ.ClassName !== 'jobtitle' && oQ.ClassName !== 'jobdescription'" class="jobProperty"
                            [ngClass]="oQ.ClassName">
                            {{ oQ.Value }}
                        </p>
                        <!-- Job Description -->
                        <div *ngIf="oQ.ClassName === 'jobdescription'" class="jobProperty" [ngClass]="oQ.ClassName">
                            <p class="description-truncate" [innerHTML]="oQ.Value | safeEmbedHtml"></p>
                        </div>
                    </div>

                    <a class="readMore linkColor dothover" (click)="toggleReadMore(jobs.indexOf(job), job)"
                        (keydown.enter)="toggleReadMore(jobs.indexOf(job), job)"
                        [tabindex]="isItemVisible(jobs.indexOf(job)) ? 0 : -1" role="button">{{'Chatbot_Read_More' |
                        translate}}</a>
                    <ng-container *ngIf="pageType === 'apply'">
                        <!-- Apply button only if job not applied -->
                        <div class="msgContainer BorderWarning readMore" *ngIf="job.ApplyDiff <= 0 && !job.Applied">
                            <span id="appLbl" aria-live="assertive" class="JobFieldsMessage">{{ 'AppliedMaxJobs'
                                |translate
                                }}</span>
                        </div>
                        <button class="primaryButton ladda-button readMore" *ngIf="!job.Applied && job.ApplyDiff > 0"
                            (click)="handleClick($event, job, 'apply')" aria-live="assertive"
                            [tabindex]="isItemVisible(jobs.indexOf(job)) ? 0 : -1">
                            <span class="ladda-label">{{ 'AriaLabel_Apply' | translate }}</span>
                        </button>
                        <!-- Applied message if job is already applied -->
                        <div *ngIf="job.Applied" class="BkgWarning applied-message-with-icon readMore"
                            [tabindex]="isItemVisible(jobs.indexOf(job)) ? 0 : -1" aria-live="polite">
                            <div>
                                <i class="fa fa-exclamation-triangle" role="presentation"></i>
                            </div>
                            <span class="message-text">{{ 'AppliedToJob' | translate }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

<!-- Modal for full job description -->
<div class="readmore-modal-backdrop" *ngIf="expandedJobIndex !== null" tabindex="-1" (click)="closeReadMore()">
    <div class="readmore-modal baseColorPalette dothover" cdkTrapFocus (click)="$event.stopPropagation()" role="dialog"
        aria-modal="true" aria-labelledby="modalTitle" (keydown.escape)="closeReadMore(); $event.stopPropagation()">
        <button class="close-icon" (click)="closeReadMore()" (keydown.enter)="closeReadMore()" tabindex="0"
            aria-label="Close">&times;</button>
        <h1 class="answer jobtitleInJobDetails" [innerHTML]="extractJobFieldsFromQuestions(parmJob?.Questions).jobtitle"
            tabindex="0" id="modalTitle"></h1>
        <p class="jobdescription anvjobdescription description-scroll-container similarjobsheaderdescription"
            [innerHTML]="extractJobFieldsFromQuestions(parmJob?.Questions).jobdescription | safeEmbedHtml" tabindex="0">
        </p>
        <div class="apply-button-wrapper"
            *ngIf="parmJob && !parmJob.Applied && parmJob.ApplyDiff > 0 && pageType === 'apply'">
            <button id="applyFromDetailBtn" class="primaryButton ladda-button"
                (click)="handleClick($event, parmJob, 'apply')" aria-live="assertive">
                <span class="ladda-label">{{ 'AriaLabel_Apply' | translate }}</span>
            </button>
        </div>
    </div>
</div>